import { render } from "./BuildNotes.vue?vue&type=template&id=f55d629c"
import script from "./BuildNotes.vue?vue&type=script&lang=js"
export * from "./BuildNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__